import {ACCEPTED_DATE_FORMATS} from '@emma-labs/shared/typescript';
import dayjs from 'dayjs';

export const isNonNull = <T>(value: T): value is NonNullable<T> => {
  return value != null;
};

export const deepEqual = <T>(prev: T, curr: T): boolean => JSON.stringify(prev) === JSON.stringify(curr);

export const dateToString = (date: Date | undefined, isUtc = false): string => {
  if (date) return dayjs(date, {utc: isUtc}).format('DD/MM/YYYY');
  return '';
};

export const stringToDate = (date: string): Date => dayjs(date, ACCEPTED_DATE_FORMATS).toDate();

export const getDateWithoutOffset = (date: Date): Date => {
  const copyDate = new Date(date);
  const timezoneOffsetinHours = copyDate.getTimezoneOffset() / 60;
  copyDate.setHours(copyDate.getHours() - timezoneOffsetinHours);
  return copyDate;
};
